<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12>
        <v-card class="app-card" elevation="0">
          <v-card-title class="app-card-title mb-0">
            <h4 class="text">Novo Pedido | {{ kindName }}</h4>          
          </v-card-title>
          <v-card-text class="app-card-content pt-4 pb-4 pl-3 pr-3">
            <component :is="currentComponentCheckout" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>            
            <v-btn outlined color="error" @click="$router.back()">
              <v-icon>chevron_left</v-icon>
              Voltar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GlobalStore from "@/store/modules/global";
import OrderCheckoutInspection from './components/OrderCheckoutInspection.vue';
import OrderCheckoutVehicleRegistrationRenewal from './components/OrderCheckoutVehicleRegistrationRenewal.vue';
import OrderCheckoutInsuranceDocumentationSubmission from './components/OrderCheckoutInsuranceDocumentationSubmission.vue';
import OrderCheckoutTacographCertificateRenewal from './components/OrderCheckoutTacographCertificateRenewal.vue';
import OrderCheckoutVehicleExclusion from './components/OrderCheckoutVehicleExclusion.vue';
import OrderCheckoutCompanyRegistrationRenewal from './components/OrderCheckoutCompanyRegistrationRenewal.vue';
import OrderCheckoutVehicleInclusion from './components/OrderCheckoutVehicleInclusion.vue';

export default {
  name: "OrderNew",

  components: {
    OrderCheckoutInspection,
    OrderCheckoutVehicleRegistrationRenewal,
    OrderCheckoutInsuranceDocumentationSubmission,
    OrderCheckoutTacographCertificateRenewal,
    OrderCheckoutVehicleExclusion,
    OrderCheckoutCompanyRegistrationRenewal,
    OrderCheckoutVehicleInclusion
  },

  data: () => ({
    kind: null,

    kindName: null,
    kindNameList: {
      'inspection': 'Autovistoria + Laudo Engenheiro Mecânico',
      'company-registration-renewal': 'Renovação Cadastro Empresa',
      'vehicle-registration-renewal': 'Renovação de Veículo',
      'insurance-documentation-submission': 'Envio Documentação Seguro',
      'tacograph-certificate-renewal': 'Renovação certificado tacógrafo',
      'vehicle-inclusion': 'Inclusão de Veículo',
      'vehicle-exclusion': 'Exclusão de Veículo'            
    },

    currentComponentCheckout: null
  }),

  watch: {
    '$route.query.kind'(newId, oldId) {      
      this.checkKind();
    }
  },

  mounted() {  
    this.checkKind();
    this.setKindName();
    this.buildCurrentComponentCheckout();   
  },

  methods: {
    checkKind() {
      const { kind } = this.$route.query;

      if (!kind) { 
        this.notifyError('Tipo de pedido não informado ou inválido.');
        return;
      }
      
      this.kind = kind;

      this.checkValidKind();
    },

    setKindName() {
      this.kindName = this.kindNameList[this.kind] || 'Tipo Desconecido';
    },

    checkValidKind() {
      if (!Object.keys(this.kindNameList).includes(this.kind)) {
        this.notifyError('Tipo de pedido inválido.');
        return;
      }

      return;
    },

    buildCurrentComponentCheckout() {      
      this.currentComponentCheckout = `OrderCheckout${this.kind
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('')}`;
    },

    notifyError(message) {
      GlobalStore.setSnackBar({
        show: true,
        message: message,
        type: 'error'
      });
    }    
  },
};
</script>